import { render, staticRenderFns } from "./step.vue?vue&type=template&id=1ba9e3f6"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"
import style0 from "./step.vue?vue&type=style&index=0&id=1ba9e3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports